// external imports
import React from 'react'
import moment from 'moment'
import { graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled, { css } from 'styled-components'

// helpers
import { up, addResponsivity } from '../lib/styles'
import {
  extractNodes,
  extractNodesFromData,
  extractNodesFromDataApplyLangs,
  extractDataAndApplyLangs,
  withSameTags,
  formatDate,
} from '../lib/helpers'
import injectIntl from '../lib/intl/injectIntl'
import { enhanceContent, replaceShortCodes } from '../lib/post'
import withExtraction from '../lib/withExtraction'

// components
import {
  Title,
  Gap,
  Row,
  Col,
  SEO,
  Link,
  Text,
  RH,
  Listing,
  ContactFormSection,
  WaveImage,
  RoundedImage,
  RoundWrapper,
  HeaderBar,
  Page,
  PageContent,
  Testimonials,
  Line,
  Button,
  ProjectList,
} from '../components'
import T from '../lib/intl/T'
import headerBarImageSrc from '../data/images/o-projektech-top.png'

// TODO
// p nahradit za div a ten nahradit za custom componentu :!!!!
const PostContent = styled.div`
  ${({ theme: { colors } }) => css`
    & > .p {
      margin-bottom: 16px;
      letter-spacing: 0.75px;
    }
    & h2,
    & h3 {
      font-size: 33px;
      font-weight: 100;
      line-height: 40px;
      margin: 0;
      padding: 0;
      margin-top: 32px;
      margin-bottom: 16px;
    }
    & a {
      color: ${colors.green};

      &:hover {
        color: ${colors.darkGreen};
        text-decoration: none;
      }
    }
  `}
`

const CONTENT_WIDTH = '768px'

class ProjectTemplate extends React.Component {
  componentDidMount() {}

  render() {
    const {
      location: { pathname },
      intl: { language, t },
    } = this.props

    // console.log('pathname', pathname, language)

    // console.log('(this.props.data', this.props.data)
    const { allProjects, project, contentImages } = this.props.data

    // console.log('contentImages', contentImages)

    const contentReactElement = enhanceContent({
      content: replaceShortCodes(project.content || ''),
      contentImages: contentImages.nodes,
    })

    // console.log('      allProjects,post,', allProjects, post)
    // const contentReactElement = enhanceContent({
    //   content: post.content,
    //   contentImages,
    //   procedures,
    // })

    const filteredProjects = allProjects
      .filter(({ id }) => id !== project.id)
      .slice(0, 3)

    return (
      <>
        <SEO
          isArticle
          title={`${project.title} · ${t('on projects - meta title')}`}
          pathname={pathname}
          description={project.metaDesc || project.perex}
          // image={
          //   post.postImage && post.postImage.filename.main.fluid.originalImg
          // }
        />
        <HeaderBar>
          <HeaderBar.Content>
            <HeaderBar.Title>
              <T>O projektech</T>
            </HeaderBar.Title>
            <HeaderBar.SubTitle>
              <T>Informace o získaných projektech</T>
            </HeaderBar.SubTitle>
          </HeaderBar.Content>

        </HeaderBar>
        <Page grey>
          <PageContent>
            <Gap gap="78px" mobileGap="60px" />
            <Row
              width="100%"
              alignItems="flex-start"
              mobileAlignItems="center"
              responsive
            >
              <Col maxWidth={CONTENT_WIDTH} width="100%">
                <Title.Section>{project.title}</Title.Section>
                <Gap gap="48px" />
                {/* <Text letterSpacing="2.25px">
                  <T>PUBLIKOVÁNO</T> {formatDate(project.publishedAt)}
                </Text>
                <Gap gap="24px" /> */}
              </Col>
            </Row>
            <Row
              width="100%"
              alignItems="flex-start"
              mobileAlignItems="center"
              responsive
            >
              <Col maxWidth={CONTENT_WIDTH} width="100%">
                <PostContent>
                  <Text>{contentReactElement}</Text>
                </PostContent>
              </Col>
              <Gap gap="62px" />
              <Col width="100%" maxWidth="452px">
                <Img
                  fluid={project.image.file && project.image.file.img.fluid}
                />
              </Col>
            </Row>
            <Gap gap="104px" mobileGap="60px" />
            <Line />
            <Gap gap="104px" mobileGap="45px" />
            <Col mobileAlignItems="center" alignItems="flex-start" bp="desktop">
              <Title.Section>
                <T>Další projekty</T>
              </Title.Section>
            </Col>
            <Gap gap="54px" mobileGap="45px" />
            <ProjectList projects={filteredProjects} />

            <Col alignItems="center">
              <Gap gap="108px" mobileGap="60px" />
              <Button.PrimaryOrange link={{ pageKey: Link.PROJECTS }}>
                <T>Další projekty</T>
              </Button.PrimaryOrange>
              <Gap gap="108px" mobileGap="60px" />
            </Col>
          </PageContent>
        </Page>

        <Page>
          <Gap gap="142px" mobileGap="60px" />
          <PageContent>
            <Testimonials />
          </PageContent>
        </Page>
        <Gap gap="198px" mobileGap="97px" />
      </>
    )
  }
}

export default injectIntl(withExtraction(ProjectTemplate))

export const pageQuery = graphql`
  query($id: ID = "") {
    ks {
      project: Project(where: { id: $id }) {
        ...ProjectFragment
      }
      allProjects(where: { isPublished: true }, sortBy: publishedAt_DESC) {
        ...ProjectFragment
      }
    }
    contentImages: allFile(
      filter: { sourceInstanceName: { eq: "uploads-images" } }
    ) {
      nodes {
        ...PostContentImage
        relativePath
      }
    }

    # contentImages: allFile(
    #   filter: { relativePath: { regex: "/^uploaded-image-/" } }
    # ) {
    #   edges {
    #     node {
    #       ...PostContentImage
    #       relativePath
    #     }
    #   }
    # }
  }
`
